<template>
  <div style="height: 95vh !important"></div>
</template>

<script>
import { ErrorAlertHandler } from "@/utils/errorAlert/ErrorAlert.js";
import { checkNotEmpty } from "@/utils/popup/common.js";
import { GA_ACTIONS, PRODUCT_TYPE } from "@/utils/Constants.js";
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      user: {},
      token: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      urlapi: process.env.VUE_APP_APIURL,
      imgExpire: require("@/assets/images/foundationIllustrationContextualVayuApplicationFail@3x.png"),
      imgSwalErr: require("@/assets/images/foundationIllustrationGenericError@3x.png"),
      productRevamp: process.env.VUE_APP_PRODUCT_REVAMP,
      prefixProductRevamp: process.env.VUE_APP_PREFIX_PRODUCT_REVAMP,
    };
  },
  created() {
    try {
      this.initDataCallFromNext();
    } catch (error) {
      this.handdleError(error);
    }
  },
  methods: {
    initDataCallFromNext() {
      this.authorizationCode = this.$route.query.authorizationCode;
      const viewOnly = this.$route.query.viewOnly;
      this.$http({
        method: "POST",
        url: this.urlapi + "api/next/validateUUID",
        data: {
          authorizationCode: this.authorizationCode,
        },
        timeout: this.timeout,
      })
        .then((response) => {
          this.mappingDataResponse(response, viewOnly);
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    async mappingDataResponse(response, viewOnly) {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf("android") > -1;
      if (response.data && response.data.status) {
        this.user.cif = response.data.cifNumber;
        this.user.creditLimit = Number(response.data.reqCreditLimit);
        this.user.documentType = response.data.documentType;
        this.user.historyUploads = response.data.checkListDocUploads;
        this.user.followupStatus = response.data.followupStatus;
        this.user.fullName = response.data.fullName;
        this.user.expiredDate = response.data.expiredDate;
        this.user.expireDay = response.data.expireDay;
        this.user.showDStatement = response.data.showDStatement;
        this.user.showDStatementErrorMsg = response.data.showDStatementErrorMsg;
        this.user.lstPriceAs = response.data.lstPriceAs;
        this.user.isAndroid = isAndroid;
        this.user.loanAppId = response.data.loanAppId;
        this.user.productName = response.data.paramDesc;
        this.user.productType = response.data.productType;
        this.user.haveListAccount = response.data.haveAccountList;
        this.user.marketCode = response.data.marketCode;
        this.user.periodStatementKtb = response.data.periodStatementKtb;
        this.user.monthCalc = response.data.monthCalc;
        this.user.accountSelected = [];
        this.user.isDocumentType = ["PENDING", "SUBMITED", "RESUBMIT"].includes(
          response.data.followupStatus.code
        );
        this.user.uuid = response.data.uuid;
        this.user.token = this.$route.query.authorizationCode;
        this.user.accessToken = this.$route.query.authorizationCode;
        this.user.channel = "NEXT";
        this.user.rdIsMandatory = response.data.rdIsMandatory;
        this.user.showRDdocument = response.data.showRDdocument;
        this.user.document_group_type = response.data.documentTypeGroup;
        this.user.document_group_type.forEach((v) => {
          v.progress = 0;
          let arry = this.user.documentType.filter(
            (docType) =>
              v.lst_doc_id.includes(docType.doc_code) && docType.doc_is_uploads
          );
          v.state = "wait";
          if (arry.length === v.lst_doc_id.length) v.state = "success";
        });
        this.user.documentType.forEach((i) => {
          i.filesReal = [];
          i.state = "wait";
          if (i.doc_is_uploads) i.state = "success";
          i.collapse = true;
          if (i.example_doc == null || !i.example_doc) {
            i.example_doc = [];
          }
        });
        this.setRoutePath();
        this.user.listener = true;

        if (this.isRevamp()) {
          const listAccount = await this.getAccountCBS(
            this.user.document_group_type,
            this.user.uuid
          );
          // console.log("listAccount", listAccount);
          this.user.listAccount = listAccount;
        }
        this.$store.dispatch("setUserData", this.user);
        if (viewOnly === "true") {
          this.$router.push("/example-doc");
        } else {
          if (this.isRevamp()) {
            this.$router.push("/summary/revamp");
          } else {
            this.$router.push("/");
          }
        }
      }
    },
    setRoutePath() {
      this.user.routerPath = {
        landing: "MainPage",
        login: "LoginPage",
        upload: "UploadPage",
        summary: "SummaryPage",
        documentGroup: "DocumentGroupPage",
        listAccount: "ListAccountPage",
        dStatement: "DstatementPage",
        landingRevamp: "SummaryRevampPage",
        statement: "StatementPage",
        preupload: "PreUploadPage",
      };
    },
    handdleError(error) {
      console.error("Handle error case:", error);
      if (this.isRevampWithPrefix()) {
        ErrorAlertHandler(error, "0", this);
      } else {
        if (error.response) {
          if (
            error.response.data != undefined &&
            error.response.data.code != undefined
          ) {
            this.getAlertNew(error.response.data.code);
          } else {
            this.getAlertNew(error.response.status);
          }
        } else {
          this.getAlertNew("9999");
        }
      }
    },
    getAlertNew(code) {
      let title = null;
      let detail = null;
      let isExpired = false;
      switch (code) {
        case "4001":
          title = "ท่านทำรายการไม่ถูกต้อง";
          detail = "กรุณาทำรายการใหม่อีกครั้ง";
          break;
        case "4005":
          title = "Token Invalid";
          detail = "กรุณาลองใหม่อีกครั้ง";
          break;
        case "4006":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          break;
        case "4007":
          title = "ข้อเสนอนี้หมดอายุแล้ว";
          detail =
            "คุณสามารถสมัครขอสินเชื่อได้อีกครั้ง เมื่อได้รับข้อเสนอจากธนาคาร";
          isExpired = true;
          break;
        case "4009":
          title = "Bad Request";
          detail =
            "กำลังอยู่ระหว่างการแก้ไข ขออภัยในความไม่สะดวก กรุณากลับมาใหม่อีกครั้ง";
          break;
        case "5003":
          (title = "ประเภทของไฟล์ไม่ถูกต้อง"),
            (detail = "กรุณาเลือกประเภทของไฟล์ได้แก่ PDF, PNG หรือ JPG");
          break;
        case "5004":
          (title = "ไฟล์มีปัญหา"),
            (detail = "ไม่สามารถเปิดไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
          break;
        case "5007":
          title = "ระบบขัดข้อง";
          detail =
            "กำลังอยู่ระหว่างการแก้ไข ขออภัยในความไม่สะดวก กรุณากลับมาใหม่อีกครั้ง";
          break;
        default:
          title = "ระบบขัดข้อง";
          detail =
            "กำลังอยู่ระหว่างการแก้ไข ขออภัยในความไม่สะดวก กรุณากลับมาใหม่อีกครั้ง";
      }
      if (isExpired) {
        this.offerExpire(title, detail);
      } else {
        this.swalError(title, detail);
      }
    },
    offerExpire(title, detail) {
      this.showAlert(this.imgExpire, title, detail);
      this.$callback.gaTagging({
        action: GA_ACTIONS.VIEW,
        category: "DGLSelfApplyAppStatusDt_Failed",
        label: ""
      },
        [
          {
            key: 38,
            value: PRODUCT_TYPE.SMART_MONEY
          }

        ]);
    },
    swalError(title, detail) {
      this.showAlert(this.imgSwalErr, title, detail);
    },
    showAlert(img, title, msg) {
      this.$swal
        .fire({
          imageUrl: img,
          position: "bottom",
          title: title,
          text: msg,
          width: 300,
          padding: "1em",
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title: "text-ktb-bold-16 dstatement-popup",
            confirmButton:
              "btn rounded-pill btn-block font-weight-bold btn-ktb-NEXT swal-button-info btn-padding",
            popup: "swal2-modal-dstatement",
            image: "swal2-image-dstatement",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$callback.gaTagging({
              action: GA_ACTIONS.CLICK,
              category: "DGLSelfApplyAppStatusDt_Failed",
              label: "DGLSelfApplyAppStatusDt_Failed_Done"
            },
              [
                {
                  key: 38,
                  value: PRODUCT_TYPE.SMART_MONEY
                }

              ]);
            this.notAuthPath();
          }
        });
    },
    notAuthPath() {
      try {
        this.$callback.exitEntryPoint();
      } catch (err) {
        console.error(err);
      }
      this.$router.push("/noAuthorized");
    },
    getHeight() {
      var h = window.innerHeight;
      if (h == 0) h = 650;
      return window.innerHeight - 45;
    },
    isRevamp() {
      const pr = this.productRevamp.split(",");
      return pr.includes(this.user.marketCode);
    },
    isRevampWithPrefix() {
      const authorizationCode = this.$route.query.authorizationCode.replace(
        /\d+/g,
        ""
      );
      const pr = this.prefixProductRevamp.split(",");
      return pr.includes(authorizationCode);
    },
    async getAccountCBS(document_group_type, token) {
      let grp01 = document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }
      const axiosInstance = axios.create({
        baseURL: this.urlapi,
        timeout: this.timeout,
        headers: { Authorization: token },
      });
      axiosInstance.interceptors.request.use(
        function (config) {
          return config;
        },
        function (error) {
          fnSet(false);
          // Do something with request error
          return Promise.reject(error);
        }
      );
      axiosInstance.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          return Promise.reject(error);
        }
      );
      let listAccount = await axiosInstance({
        method: "GET",
        url: "/api/accountInfo?docIdStatement=" + docIdStatement,
      })
        .then((response) => {
          const listAccount = response.data.filter(
            (item) => !checkNotEmpty(item.errorMsg)
          );
          return listAccount;
        })
        .catch((error) => {
          console.error("Error account info", error);
          ErrorAlertHandler(error, "1", this);
          return [];
        });
      // console.log("listAccount", listAccount);
      return listAccount;
    },
  },
};
</script>
